import {EOsaActions, OsaActions} from "../../actions/osa/osa.actions";
import {initialOsaScanningState, IOsaScanningState} from "../../state/osa/osa.state";

export const osaScanningReducers = (
  state = initialOsaScanningState,
    action: OsaActions
):IOsaScanningState =>{
  switch (action.type) {
    case EOsaActions.GetScanning: {
      return {
        ...state
      };
    }
    case EOsaActions.GetScanningSuccess: {
      return {
        ...state,
        data:action.payload,
        isLoaded: true
      };
    }
    case EOsaActions.GetScanningFailure: {
      return {
        ...state,
        data:[],
        isLoaded: false
      };
    }
    default:
      return state;


  }
};
